import { render, staticRenderFns } from "./PortfolioStructure.vue?vue&type=template&id=8f7d3ef2&"
import script from "./PortfolioStructure.vue?vue&type=script&lang=js&"
export * from "./PortfolioStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports